import React from 'react';
import styles from './after-empty-cart.module.css';
import RecommendedProductBlock from '@/_application/pages/home/components/recommend-product-block.mobile';
import ProductsSuggestion from '@/_application/modules/products/components/products-suggestion/products-suggestion';

export const AfterEmptyCart = () => {
    return (
        <div className={styles.container}>
            <div className={styles.mobileWrapper}>
                <RecommendedProductBlock />
            </div>
            <div className={styles.desktopWrapper}>
                <ProductsSuggestion />
            </div>
        </div>
    );
};
